import React from 'react'

function FilterBar({ children }) {

  return (
    <div 
      className="filter-bar">
      {children}
    </div>
  )
}

export default FilterBar
